module.exports = "Test Home Component\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app/home/home.component.html
// module id = ./src/components/app/home/home.component.html
// module chunks = main